import EditOutlined from "@mui/icons-material/EditOutlined";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import { NavLink, Outlet, useRouteLoaderData } from "react-router-dom";
import PlaceholderedImage from "../../../../components/placeholderImage";
import PageTitle from "../../../../components/PageTitle";

export default function ObjectPhotos() {
    const hotelObj = (useRouteLoaderData('obj_layout')).hotelObj;
    return (
        <>
            <PageTitle title={`Фото об'єкта: ${hotelObj?.name || hotelObj?.id || "ID"}`} />
            <Stack direction='column' spacing={2}>
                <Box>
                    <Typography variant='h4'>Галерея основного об'єкту</Typography>
                    <Typography>
                        Головне зображення
                    </Typography>
                    <Box
                        sx={{ maxWidth: '300px' }}
                    >
                        <PlaceholderedImage src={hotelObj.image} alt='Зображення готелю' style={{ width: '100%' }} />
                    </Box>
                    {hotelObj.hotel_image.length > 0 && (
                        <>
                            <Typography>
                                Галерея фото
                            </Typography>
                            <Stack direction='row' spacing={1}>
                                {hotelObj.hotel_image.map((el, index) => (
                                    <Box key={index} sx={{ maxWidth: '150px', maxHeight: '150px', overflow: 'auto' }}>
                                        <PlaceholderedImage src={`${el}`} style={{ width: '100%' }} alt={`галерея №${index}`} />
                                    </Box>
                                ))}
                            </Stack>
                        </>
                    )}
                    <Button
                        variant="contained"
                        component={NavLink}
                        to='edit'
                        sx={{ width: 'fit-content', textTransform: 'uppercase' }}
                        startIcon={<EditOutlined />}
                    >
                        Редагувати
                    </Button>
                </Box>
                {hotelObj.children_obj && (
                    <>

                        {hotelObj.children_obj.map((childrenObj, index) => (
                            <Box key={index}>
                                <Divider orientation="horizontal" />
                                <Box>
                                    <Typography variant='h5'>Галерея підоб'єкту {childrenObj.name}</Typography>
                                </Box>
                                <Typography>
                                    Головне фото
                                </Typography>
                                <Box
                                    sx={{ maxWidth: '300px' }}
                                >
                                    <PlaceholderedImage src={childrenObj.image} alt='Зображення готелю' style={{ width: '100%' }} />
                                </Box>
                                {childrenObj.hotel_image.length > 0 && (
                                    <>
                                        <Typography>
                                            Галерея фото підоб'єкта
                                        </Typography>
                                        <Stack direction='row' spacing={1}>
                                            {childrenObj.hotel_image.map((el, index) => (
                                                <Box key={index} sx={{ maxWidth: '150px', maxHeight: '150px', overflow: 'auto' }}>
                                                    <PlaceholderedImage src={`${el}`} style={{ width: '100%' }} alt={`галерея №${index}`} />
                                                </Box>
                                            ))}
                                        </Stack>
                                    </>
                                )}
                                <Button
                                    variant="contained"
                                    component={NavLink}
                                    to={`children/${childrenObj.id}/edit`}
                                    sx={{ width: 'fit-content', textTransform: 'uppercase' }}
                                    startIcon={<EditOutlined />}
                                >
                                    Редагувати зображення підоб'єкту
                                </Button>
                            </Box>
                        ))}
                    </>)}
            </Stack>

            <Outlet />
        </>
    )
}
